import { getPathNetworkUtil } from '../get-path'
import { REDUX_KEY } from '../../../redux/constants/key'

import { getObjectUtil } from 'packages/src'

function getStatusNetworkUtil (request, state) {
  return (
    getObjectUtil(state, `${getPathNetworkUtil(request)}.${REDUX_KEY.STATUS}`)
  )
}

export { getStatusNetworkUtil }
